import { useParams } from 'react-router-dom'

import {
  LoadingContainer,
  Panels,
  Bar,
  LegacyPage,
  Modal,
  Model,
  Breadcrumb,
} from 'peach/components'
import { getName } from 'peach/helpers'

import { useGetCaseById, useUpdateCase } from 'core/types'

import UpdateCaseForm from './UpdateCaseForm'

const PersonCase = () => {
  const { personId, caseId } = useParams<{
    personId?: string
    caseId?: string
  }>()

  const {
    data: personCase,
    isLoading,
    error,
  } = useGetCaseById({
    personId,
    caseId,
  })

  const { mutateAsync: updateCase } = useUpdateCase({
    personId,
    caseId,
  })

  const title = isLoading ? 'Loading...' : getName(personCase)

  return (
    <Panels header={<Bar title={title} />}>
      <Modal
        initialValue={personCase}
        onSubmit={async (_caseData, diff) => {
          await updateCase(diff)
        }}
        title='Update Case'
      >
        <UpdateCaseForm />
      </Modal>
      <Breadcrumb title={title} />
      <LoadingContainer error={error} loading={isLoading}>
        <LegacyPage.Full>
          <Model.Item json={personCase} />
        </LegacyPage.Full>
      </LoadingContainer>
    </Panels>
  )
}

export default PersonCase
